<app-form-input *ngIf="displayStar"
	[parentForm]="parentForm"
	[disabled]="disabled"
	[value]="objetPrincipal.classPrincipale"

	[label]="step2.getclassprincipale"
	[type]="'autocompleteWithStar'" [rule]="'pattern_17|required'"
	[errorMessage]="{'required' : 'ctr_203_HorsDef', 'pattern' : 'ctr_204_HorsDef'}"
	[autoCompleteType]="'CPV'" [autoCompleteTypeIndex]="1"
	[maxLength]="8"
	[name]="getUid()+'_SepAtt_classPrincipale'"
  [preferenceType] = "typeCpv"
  (preferenceSelected)="chargeDonneePreference($event)">
</app-form-input>
<app-form-input *ngIf="!displayStar"
	[parentForm]="parentForm"
	[disabled]="disabled"
	[value]="objetPrincipal.classPrincipale"

	[label]="step2.getclassprincipale"
	[type]="'autocomplete'" [rule]="'pattern_17|required'"
	[errorMessage]="{'required' : 'ctr_203_HorsDef', 'pattern' : 'ctr_204_HorsDef'}"
	[autoCompleteType]="'CPV'" [autoCompleteTypeIndex]="1"
	[maxLength]="8"
	[name]="getUid()+'_SepAtt_classPrincipale'">
</app-form-input>
<app-form-input

	[label]="step2.getclasssupplementaire_liste_avi_"
	[name]="getUid() + '_SepAtt_classSupplementaire'"
	[parentForm]="parentForm"
	[disabled]="disabled"
	[isCPV]="true"
	[type]="'chips'"
	[rule]="'pattern_15'"
	[errorMessage]="{'pattern' : 'ctr_204_HorsDef'}"
	[value]="objetPrincipal.classSupplementaire"
	[autoCompleteType]="'CLASSSUPPLEMENTAIRE'" [autoCompleteTypeIndex]="0"
	[maxLength]="3"
>

<!---->


